import "./styles/main.scss";
import widgetImage from "./assets/accessiblityassist-pro-widget.webp";
import brandLogo from "./assets/accessiblity-assist-pro-logo-header.png";
import favicon16 from "./assets/favicon-16x16.png";
import favicon32 from "./assets/favicon-32x32.png";
import appleTouchIcon from "./assets/apple-touch-icon.png";

const year = document.querySelector("[data-year]");
const heroWidget = document.querySelector("[data-hero-widget]");
const brandLogoImage = document.querySelector("[data-brand-logo]");

const setIconLink = ({ rel, href, sizes, type }) => {
  const selector = sizes ? `link[rel="${rel}"][sizes="${sizes}"]` : `link[rel="${rel}"]`;
  const link = document.querySelector(selector) || document.createElement("link");

  link.rel = rel;
  link.href = href;

  if (sizes) {
    link.sizes = sizes;
  }

  if (type) {
    link.type = type;
  }

  if (!link.parentNode) {
    document.head.appendChild(link);
  }
};

if (year) {
  year.textContent = new Date().getFullYear();
}

if (heroWidget) {
  heroWidget.src = widgetImage;
}

if (brandLogoImage) {
  brandLogoImage.src = brandLogo;
}

setIconLink({
  rel: "icon",
  href: favicon32,
  sizes: "32x32",
  type: "image/png"
});
setIconLink({
  rel: "icon",
  href: favicon16,
  sizes: "16x16",
  type: "image/png"
});
setIconLink({
  rel: "apple-touch-icon",
  href: appleTouchIcon,
  sizes: "180x180"
});
